import { compareNullableDate, compareNullableText } from '@partou/core';
import type { ChildObservation } from '../types';
import { type ObservationSortField, OBSERVATION_ORIGINS, OBSERVATION_STATUSES } from '../constants';

export function compareObservationsBy(
  field: ObservationSortField,
  first: ChildObservation,
  second: ChildObservation,
): number {
  switch (field) {
    case 'origin':
      return OBSERVATION_ORIGINS.indexOf(first.origin) - OBSERVATION_ORIGINS.indexOf(second.origin);
    case 'status':
      return OBSERVATION_STATUSES.indexOf(first.status) - OBSERVATION_STATUSES.indexOf(second.status);
    case 'dueDate':
      return new Date(first.dueDate).getTime() - new Date(second.dueDate).getTime();
    case 'filledInBy':
      return compareNullableText(first.filledInBy, second.filledInBy);
    case 'completedAt':
      return compareNullableDate(first.completedAt, second.completedAt);
  }
}
